import { render } from "./PromoBar.vue?vue&type=template&id=558d5f33"
import script from "./PromoBar.vue?vue&type=script&lang=js"
export * from "./PromoBar.vue?vue&type=script&lang=js"

import "./PromoBar.vue?vue&type=style&index=0&id=558d5f33&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__